import clsx from "clsx";

import type { TextFieldProps } from "@/ui/atoms/TextField";
import TextField from "@/ui/atoms/TextField";

export type SearchBarProps = Omit<
    TextFieldProps,
    "children" | "value" | "onChange" | "name"
> & {
    name?: string;
    placeholder?: string;
    value: string;
    onChange: (value: string) => void;
};

export const testId = "SearchBar";
const SearchBar = (props: SearchBarProps) => {
    const { className, value, onChange, placeholder, ...otherProps } = props;

    return (
        <TextField
            data-testid={testId}
            className={clsx([testId, className])}
            leadingIcon="magnifying-glass"
            name="search-bar"
            placeholder={placeholder}
            value={value}
            onChange={e => onChange(e.target.value)}
            {...otherProps}
        />
    );
};

export default SearchBar;
